<template>
  <main class="main page-inside cart-page balance-page">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">MY BALANCE</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <section class="section page-body-section cart-section balance-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div class="left">
            <div class="balance-amount">
              <div class="desc big">{{ balance }}</div>
              <img src="./../images/coin2.svg" class="coin" />
            </div>
            <div class="desc desc-32">
              <b>{{ $t("TOP UP BALANCE") }}</b>
            </div>
            <label>
              <div class="desc">{{ $t("Enter amount:") }}</div>
              <input
                type="text"
                @input="allowOnlyNumbers"
                placeholder="Enter amount"
                v-model="amount"
              />
            </label>
            <div class="radio-list button-container"></div>
            <div class="desc desc-32 topup-amount">
              <span>1</span>
              <img src="./../images/coin2.svg" class="coin" />
              <span v-if="$parent.currencyRate"
                >= {{ $parent.currencyRate.toFixed(2) }} {{ currency }}</span
              >
            </div>
            <button
              :class="['button action', { disabled: !requiredFieldsAreFilled }]"
              @click="toCheckout"
            >
              <span>{{ $t("TOP UP") }}</span>
            </button>
          </div>
          <div class="right">
            <div class="tabs">
              <button
                :class="['desc desc-32', { active: tab == 1 }]"
                @click="tab = 1"
              >
                {{ $t("ORDER HISTORY") }}
              </button>
              <button
                :class="['desc desc-32', { active: tab == 2 }]"
                @click="tab = 2"
              >
                {{ $t("PAYMENT HISTORY") }}
              </button>
            </div>
            <div class="profile-table" v-if="tab == 1">
              <div class="profile-table-wrapper profile-form-wrapper">
                <div class="table-container" v-if="$parent.orderHistory.length">
                  <table>
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>Date/time</td>
                        <td>Item name</td>
                        <td>Total</td>
                        <td>Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                        <td>{{ item.id }}</td>
                        <td>{{ $parent.formatDate(item.created_at) }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.sum }} {{ $parent.currency }}</td>
                        <td
                          :class="[
                            { green: item.status == 'Accepted' },
                            { white: item.status == 'Processing' },
                          ]"
                        >
                          {{ item.status }}
                        </td>
                        <!-- <td>
                        <a class="offer-modal-open" @click="$emit('openOfferDetailsModal', item)">View</a>
                      </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="desc title-empty"
                  v-if="!$parent.orderHistory.length"
                >
                  {{ $t("Empty!") }}
                </div>
              </div>
            </div>
            <div class="profile-table" v-if="tab == 2">
              <div class="profile-table-wrapper profile-form-wrapper">
                <div
                  class="table-container"
                  v-if="$parent.depositHistory.length"
                >
                  <table>
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>Date</td>
                        <td>Amount</td>
                        <td>Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in $parent.depositHistory" :key="i">
                        <td>{{ item.id }}</td>
                        <td>{{ $parent.formatDate(item.created_at) }}</td>
                        <td>
                          <span>{{ item.points }} </span>
                          <img src="./../images/coin2.svg" class="coin" />
                        </td>
                        <td
                          :class="[
                            { green: item.status == 'Success' },
                            { white: item.status == 'Pending' },
                          ]"
                        >
                          {{ item.status }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="desc title-empty"
                  v-if="!$parent.depositHistory.length"
                >
                  {{ $t("Empty!") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: "BalancePage",
  props: ["currency"],
  components: {},
  data: function () {
    return {
      amount: "25",
      amountList: [25, 50, 100, 250, 500],
      balance: 0,
      tab: 1,
    };
  },
  watch: {
    currency: function () {
      if (this.currency) {
        this.getCurr();
      }
    },
  },
  mounted() {
    if (this.currency) {
      this.getCurr();
    }
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (this.amount) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  methods: {
    getCurr() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile?currency=" + this.currency)
        .then((res) => {
          this.balance = res.data.balance;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    toCheckout() {
      this.$emit("setTopUpAmount", this.amount);
    },
  },
};
</script>
